/**
 * Onde o anel de luz do hero fica, em px CSS relativos ao hero.
 * Compartilhado entre o shader e a animação de abertura (o anel do logo
 * voa exatamente para esta posição antes de virar luz).
 */
export default function ringGeometry(width, height) {
  if (width < 900) {
    const r = Math.min(width * 0.44, height * 0.26);
    return { cx: width * 0.5, cy: height * 0.3, r };
  }
  const r = Math.min(width * 0.27, height * 0.4);
  return { cx: width * 0.66, cy: height * 0.5, r };
}
